export default __webpack_public_path__ + "static/media/White0006.7151dc6d.png";